import classNames, { Argument } from "classnames/dedupe";
import React, { ElementType, FC, ReactNode } from "react";

export interface INavListProps {
  /** Aria label attribute of outer element */
  ariaLabel?: string;
  /**
   * Sets a custom html element for this component
   *
   * @default 'div'
   */
  as?: ElementType;

  /**
   * The custom set of css classes used to style component
   *
   */
  classes?: {
    /** Styles applied to outer element. */
    root?: Argument;
  };
  children?: ReactNode;
}

const NavList: FC<INavListProps> = ({
  as: Component = "nav",
  ariaLabel,
  classes,
  children,
}) => (
  <Component
    className={classNames("header-nav__item", classes?.root)}
    aria-label={ariaLabel}
  >
    <ul className="nav-list">{children}</ul>
  </Component>
);

export default NavList;
